export enum NotationType {
  Alert = 'Alert',
  Update = 'Update',
  Encouragement = 'Encouragement',
  DataInsight = 'DataInsight',
  CheckIn = 'CheckIn',
  GroupMessage = 'GroupMessage',
}
